export const formatDate = (date: string) => {
  if (date) {
    const dateParse = new Date(date);
    return dateParse.toISOString().slice(0, 10).split('-').reverse().join('/');
  }
  return '';
};
